import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE} from 'util/constants';

const
    name = 'regions',
    exports = storeModuleFactory({
        name,
        endpoint:           endpoints.regions.endpoint,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        transformResultsFn: ({results}) => Object.keys(results).reduce((ret, vendor) => ret.concat(Object.keys(results[vendor]).map(key => ({
            ...results[vendor][key],
            fullLabel: `${results[vendor][key].title} [${results[vendor][key].code}]`,vendor
        }))), [])
    });


module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/regions.js